function messageIE () {
  var trident = {
    string: navigator.userAgent.match(/MSIE \d+\.\d+/)
  }

  trident.version = trident.string ? trident.string.toString().split(' ')[1].split('.')[0] : false

  if (trident.version && trident.version <= 10) {
    alert('Для корректной работы с сайтом необходимо установить версию браузера не ниже IE 11')
  }
}

messageIE()

